import { render, staticRenderFns } from "./PtrBackgroundLoading.vue?vue&type=template&id=6cfa2b80&scoped=true&"
import script from "./PtrBackgroundLoading.vue?vue&type=script&lang=js&"
export * from "./PtrBackgroundLoading.vue?vue&type=script&lang=js&"
import style0 from "./PtrBackgroundLoading.vue?vue&type=style&index=0&id=6cfa2b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa2b80",
  null
  
)

export default component.exports